export default __webpack_public_path__ + "static/media/install_app.0ad2291a.gif";